<script>
import General from '@/services/General'
import validationMessages from '@/components/validations'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import vue2Dropzone from 'vue2-dropzone'

import 'flatpickr/dist/flatpickr.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'modalEditGiveawayPopup',
  mixins: [validationMixin],
  components: {
    validationMessages,
    flatPickr,
    vueDropzone: vue2Dropzone,
  },
  props: {
    popupsData: {
      type: Object,
      default: () => null,
    },
    groupOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const defaultStartDate = moment().format('YYYY-MM-DD')
    const defaultEndDate = moment().add(7, 'days').format('YYYY-MM-DD')

    return {
      showModal: false,
      tryingToSubmit: false,
      submitted: false,
      acceptedFileTypeErrorMessage: '',
      acceptedFileTypeError: false,
      dateRangeError: '',
      audienceOptions: [
        { value: 'ALL', text: 'All users' },
        { value: 'GROUP', text: 'User segment(group)' },
      ],
      additionalOptIns:[],
      showAdditionalOptInFields:false,
      emptyOptInField: false,
      popup: {
        id: null,
        campaign_name: '',
        target_audience: 'ALL',
        group_id: '',
        popup_title: '',
        popup_description: '',
        opt_in_text: '',
        terms_url: '',
        image_file: null,
        success_title: '',
        success_description: '',
        button_cta_text: '',
        button_cta_url: '',
      },
      existingImageUrl: '',
      duration: {
        start_date: defaultStartDate,
        start_time: '00:00',
        end_date: defaultEndDate,
        end_time: '23:59',
      },
      startDateConfig: {
        dateFormat: 'Y-m-d',
      },
      endDateConfig: {
        dateFormat: 'Y-m-d',
      },
      timePickerConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
        minuteIncrement: 1,
      },
      dropzoneOptions: {
        url: '/',
        autoProcessQueue: false,
        addRemoveLinks: false,
        thumbnailWidth: 150,
        thumbnailMethod: 'contain',
        maxFilesize: 1,
        maxFiles: 1,
        acceptedFiles: 'image/jpeg,image/png',
        dictMaxFilesExceeded: 'You can only upload one image',
        dictFileTooBig: 'Image is larger than 1MB',
        uploadMultiple: false,
      },
      csrf_token: localStorage.getItem('csrf_token'),
    }
  },
  validations() {
    return {
      popup: {
        campaign_name: { required },
        target_audience: { required },
        group_id: {
          required: requiredIf(function () {
            return this.popup.target_audience === 'GROUP'
          }),
        },
        popup_title: { required },
        popup_description: { required },
        opt_in_text: { required },
        terms_url: { required },
        image_file: {
          required: requiredIf(function () {
            return !this.existingImageUrl
          }),
        },
        success_title: { required },
        success_description: { required },
        button_cta_text: { required },
      },
      duration: {
        start_date: { required },
        start_time: { required },
        end_date: { required },
        end_time: { required },
      },
    }
  },
  computed: {
    hasGroupSelection() {
      return this.popup.target_audience === 'GROUP'
    },
    formattedStartDateTime() {
      return this.combineDateTime(this.duration.start_date, this.duration.start_time)
    },
    formattedEndDateTime() {
      return this.combineDateTime(this.duration.end_date, this.duration.end_time)
    },
  },
  watch: {
    popupsData: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.populateFromPopup(newVal)
        }
      },
    },
    'popup.target_audience'(value) {
      if (value !== 'GROUP') {
        this.popup.group_id = ''
        if (this.$v?.popup?.group_id?.$reset) {
          this.$v.popup.group_id.$reset()
        }
      }
    },
  },
  methods: {
    toggleOptInFields() {
      this.showAdditionalOptInFields = true;
      this.addOptInField();
    },
    addOptInField() {
      this.additionalOptIns.push("");
    },
    removeOptIn(index) {
      this.additionalOptIns.splice(index, 1);
    },
    openPicker(refName) {
      const ref = this.$refs[refName]
      const instance = ref?.flatpickr || ref?.fp
      if (instance && typeof instance.open === 'function') {
        instance.open()
        return
      }
      const inputEl = ref?.$el?.querySelector?.('input') || ref?.$el || ref
      inputEl?.focus?.()
    },
    openStartDatePicker() {
      this.openPicker('startDatePicker')
    },
    openEndDatePicker() {
      this.openPicker('endDatePicker')
    },
    openStartTimePicker() {
      this.openPicker('startTimePicker')
    },
    openEndTimePicker() {
      this.openPicker('endTimePicker')
    },
    populateFromPopup(popup) {
      let optIns = [];
      if(popup.additional_opt_ins){
        optIns = popup.additional_opt_ins;
      }

      this.additionalOptIns = optIns.map(optin => optin.participation_agreement_text).filter((_, index) => index !== 0);


      this.popup = {
        id: popup?.id || null,
        campaign_name: popup?.name || '',
        target_audience: popup?.recipient || 'ALL',
        group_id: popup?.group_id || '',
        popup_title: popup?.title || '',
        popup_description: popup?.bottom_text || '',
        opt_in_text: popup?.participation_agreement_text || '',
        terms_url: popup?.participation_tnc_url || '',
        image_file: null,
        success_title: popup?.success_page?.page_popup_title || '',
        success_description: popup?.success_page?.page_popup_description || '',
        button_cta_text: popup?.success_page?.button_cta_text || '',
        button_cta_url: popup?.success_page?.button_landing_url || '',
      }

      this.existingImageUrl = popup?.background_image || popup?.image || ''

      const startMoment = popup?.date_from ? moment(popup.date_from) : null
      const endMoment = popup?.date_to ? moment(popup.date_to) : null

      this.duration = {
        start_date: startMoment ? startMoment.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        start_time: startMoment ? startMoment.format('HH:mm') : '00:00',
        end_date: endMoment ? endMoment.format('YYYY-MM-DD') : moment().add(7, 'days').format('YYYY-MM-DD'),
        end_time: endMoment ? endMoment.format('HH:mm') : '23:59',
      }

      this.dateRangeError = ''
      this.acceptedFileTypeError = false
      this.acceptedFileTypeErrorMessage = ''
      this.submitted = false
      if (this.$refs.giveawayDropzone) {
        this.$refs.giveawayDropzone.removeAllFiles(true)
      }
    },
    refreshPopupData() {
      this.$emit('onRefresh')
    },
    combineDateTime(date, time) {
      if (!date || !time) {
        return ''
      }

      return moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')
    },
    validateDateRange() {
      this.dateRangeError = ''
      const hasAllDateParts = [
        this.duration.start_date,
        this.duration.start_time,
        this.duration.end_date,
        this.duration.end_time,
      ].every(Boolean)

      if (!hasAllDateParts) {
        this.dateRangeError = 'Please choose both start and end date with time.'
        return false
      }

      if (!this.formattedStartDateTime || !this.formattedEndDateTime) {
        return false
      }

      if (moment(this.formattedEndDateTime).isBefore(moment(this.formattedStartDateTime))) {
        this.dateRangeError = 'End date must be after start date.'
        return false
      }

      return true
    },
    updateGiveawayPopup() {
      if (this.acceptedFileTypeError) {
        return
      }

      for (let field of this.additionalOptIns) {
        if (field == '') {
          this.emptyOptInField = true;
          return;
        } else {
          this.emptyOptInField = false
        }
      }
      this.tryingToSubmit = true
      this.submitted = true
      this.$v.$touch()

      const hasValidRange = this.validateDateRange()

      if (this.$v.$invalid || !hasValidRange) {
        if (process.env.NODE_ENV !== 'production') {
          const invalidFields = []

          const traverseValidationTree = (validationNode, path = []) => {
            if (!validationNode || typeof validationNode !== 'object') {
              return
            }

            if (validationNode.$params) {
              Object.keys(validationNode.$params).forEach((rule) => {
                if (validationNode.$dirty && !validationNode[rule]) {
                  const fieldPath = path.length ? path.join('.') : 'root'
                  invalidFields.push(`${fieldPath} (${rule})`)
                }
              })
            }

            Object.keys(validationNode)
              .filter((key) => !key.startsWith('$'))
              .forEach((key) => {
                traverseValidationTree(validationNode[key], [...path, key])
              })
          }

          traverseValidationTree(this.$v.popup, ['popup'])
          traverseValidationTree(this.$v.duration, ['duration'])

          if (!hasValidRange && !invalidFields.includes('duration (date_range)')) {
            invalidFields.push('duration (date_range)')
          }

          // eslint-disable-next-line no-console
          console.warn('Giveaway popup update validation failed:', invalidFields)
        }

        this.tryingToSubmit = false
        return
      }

      const formData = new FormData()
      formData.append('name', this.popup.campaign_name)
      formData.append('title', this.popup.popup_title)
      formData.append('bottom_text', this.popup.popup_description)
      formData.append('participation_agreement_text', this.popup.opt_in_text)
      if (this.additionalOptIns.length === 0) {
        formData.append('additional_opt_ins', []);
      } else {
        this.additionalOptIns.forEach(opt => {
          formData.append('additional_opt_ins[]', opt);
        });
      }
      formData.append('participation_tnc_url', this.popup.terms_url)
      formData.append('action_text', this.popup.button_cta_text)
      formData.append('action', this.popup.button_cta_url || '')
      formData.append('type', 'participation')
      formData.append('date_from', this.formattedStartDateTime)
      formData.append('date_to', this.formattedEndDateTime)
      formData.append('recipient', this.popup.target_audience)
      formData.append('csrf_token', this.csrf_token)
      formData.append('_method', 'PATCH')
      formData.append('page_popup_title', this.popup.success_title)
      formData.append('page_popup_description', this.popup.success_description)
      formData.append('button_cta_text', this.popup.button_cta_text)
      formData.append('button_landing_url', this.popup.button_cta_url || '')

      if (this.popup.image_file) {
        formData.append('file', this.popup.image_file)
      }

      if (this.hasGroupSelection) {
        formData.append('group_id', this.popup.group_id)
      }

      if (process.env.NODE_ENV !== 'production') {
        const payloadPreview = {}
        formData.forEach((value, key) => {
          payloadPreview[key] = value
        })
        // eslint-disable-next-line no-console
        console.debug('Updating giveaway popup payload', payloadPreview)
      }

      General.updateHypePopUp(this.popup.id, formData)
        .then((response) => {
          const res = response.data.data ? response.data.data : false
          if (res) {
            this.successmsg('Giveaway popup updated!')
            this.refreshPopupData()
            this.closeModal()
          } else {
            this.failedmsg('Failed to update giveaway popup.')
          }
        })
        .catch((error) => {
          const resData = error?.response?.data?.error ? error.response.data.error : 'Failed'
          const errorMsg = Array.isArray(resData) ? resData[0] : resData
          this.failedmsg(errorMsg)
        })
        .finally(() => {
          this.tryingToSubmit = false
        })
    },
    closeModal() {
      this.showModal = false
    },
    resetProps() {
      this.additionalOptIns = [],
      this.showAdditionalOptInFields = false,
      this.submitted = false
      this.acceptedFileTypeErrorMessage = ''
      this.acceptedFileTypeError = false
      this.dateRangeError = ''
      this.popup.image_file = null
      if (this.$refs.giveawayDropzone) {
        this.$refs.giveawayDropzone.removeAllFiles(true)
      }
    },
    selectFile(files) {
      setTimeout(() => {
        const dropzoneFiles = this.$refs.giveawayDropzone?.dropzone?.files || []
        const [file] = files
        if (!file) {
          return
        }

        if (file.size > 1048576) {
          this.acceptedFileTypeErrorMessage = 'Max file size is 1MB.'
          this.acceptedFileTypeError = true
        } else if (!['image/png', 'image/jpeg'].includes(file.type)) {
          this.acceptedFileTypeErrorMessage = 'Only PNG or JPG images are allowed.'
          this.acceptedFileTypeError = true
        } else {
          this.acceptedFileTypeErrorMessage = ''
          this.acceptedFileTypeError = false
        }

        if (dropzoneFiles.length > 1) {
          dropzoneFiles.forEach((value, index) => {
            if (index !== 0) {
              this.$refs.giveawayDropzone.removeFile(value)
            }
          })
        }

        this.popup.image_file = !this.acceptedFileTypeError ? dropzoneFiles[0] : null
        if (this.popup.image_file) {
          this.existingImageUrl = ''
        }
      }, 200)
    },
    removeImage() {
      if (this.$refs.giveawayDropzone) {
        this.$refs.giveawayDropzone.removeAllFiles(true)
      }
      this.popup.image_file = null
    },
  },
}
</script>

<template>
  <b-modal
    id="edit_giveaway_popup"
    size="xl"
    v-model="showModal"
    @shown="popupsData && populateFromPopup(popupsData)"
    @hidden="resetProps"
    hide-header
    hide-footer
    body-class="p-0"
    centered
  >
    <div class="giveaway-modal">
      <header class="giveaway-modal__hero">
        <h2>Edit giveaway popup</h2>
        <p>Update your giveaway campaign configuration</p>
      </header>

      <b-form @submit.prevent="updateGiveawayPopup">
        <section class="giveaway-card">
          <header class="giveaway-card__header">
            <h3>Basic Information</h3>
            <p>Essential details about your giveaway campaign</p>
          </header>

          <b-form-group
            label="Campaign name *"
            label-for="edit-giveaway-campaign-name"
            class="mb-4"
          >
            <b-form-input
              id="edit-giveaway-campaign-name"
              v-model.trim="popup.campaign_name"
              :class="{ 'is-invalid': submitted && $v.popup.campaign_name.$error }"
              placeholder="Enter campaign name (internal use only)"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Campaign name'"
              :validationName="$v.popup.campaign_name"
            />
          </b-form-group>

          <div class="mb-1">
            <label class="form-label d-block">Campaign duration *</label>
          </div>

          <div class="row g-3 flex-wrap">
            <div class="col-12 col-lg-6">
              <div class="giveaway-datetime">
                <span class="giveaway-datetime__label">From</span>
                <div class="giveaway-datetime__inputs">
                  <div class="giveaway-input-icon">
                    <flat-pickr
                      ref="startDatePicker"
                      v-model="duration.start_date"
                      :config="startDateConfig"
                      :class="['form-control pe-4', submitted && $v.duration.start_date.$error ? 'is-invalid' : '']"
                      placeholder="Pick date"
                    />
                    <i
                      class="uil uil-calendar-alt giveaway-input-icon__icon"
                      @click="openStartDatePicker"
                    ></i>
                  </div>
                  <div class="giveaway-input-icon">
                    <flat-pickr
                      ref="startTimePicker"
                      v-model="duration.start_time"
                      :config="timePickerConfig"
                      :class="['form-control pe-4', submitted && $v.duration.start_time.$error ? 'is-invalid' : '']"
                    />
                    <i
                      class="uil uil-clock giveaway-input-icon__icon"
                      @click="openStartTimePicker"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="giveaway-datetime">
                <span class="giveaway-datetime__label">To</span>
                <div class="giveaway-datetime__inputs">
                  <div class="giveaway-input-icon">
                    <flat-pickr
                      ref="endDatePicker"
                      v-model="duration.end_date"
                      :config="endDateConfig"
                      :class="['form-control pe-4', submitted && $v.duration.end_date.$error ? 'is-invalid' : '']"
                      placeholder="Pick date"
                    />
                    <i
                      class="uil uil-calendar-alt giveaway-input-icon__icon"
                      @click="openEndDatePicker"
                    ></i>
                  </div>
                  <div class="giveaway-input-icon">
                    <flat-pickr
                      ref="endTimePicker"
                      v-model="duration.end_time"
                      :config="timePickerConfig"
                      :class="['form-control pe-4', submitted && $v.duration.end_time.$error ? 'is-invalid' : '']"
                    />
                    <i
                      class="uil uil-clock giveaway-input-icon__icon"
                      @click="openEndTimePicker"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="dateRangeError" class="text-danger mt-2">
            {{ dateRangeError }}
          </div>
        </section>

        <section class="giveaway-card">
          <header class="giveaway-card__header">
            <h3>Recipients</h3>
            <p>Choose who can see and participate in this giveaway</p>
          </header>

          <b-form-group
            label="Target audience *"
            label-for="edit-giveaway-target-audience"
            class="mb-0"
          >
            <b-form-select
              id="edit-giveaway-target-audience"
              v-model="popup.target_audience"
              :options="audienceOptions"
              :class="{ 'is-invalid': submitted && $v.popup.target_audience.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Target audience'"
              :validationName="$v.popup.target_audience"
            />
          </b-form-group>

          <b-form-group
            v-if="hasGroupSelection"
            label="User segment *"
            class="mt-4 mb-0"
          >
            <b-form-select
              v-model="popup.group_id"
              :options="groupOptions"
              :class="{ 'is-invalid': submitted && $v.popup.group_id.$error }"
              placeholder="Select user segment"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'User segment'"
              :validationName="$v.popup.group_id"
            />
          </b-form-group>
        </section>

        <section class="giveaway-card">
          <header class="giveaway-card__header">
            <h3>Popup content</h3>
            <p>Configure what users see in the giveaway popup</p>
          </header>

          <b-form-group
            label="Popup title *"
            class="mb-4"
          >
            <b-form-input
              v-model.trim="popup.popup_title"
              placeholder="e.g., Win VIP Tickets"
              :class="{ 'is-invalid': submitted && $v.popup.popup_title.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Popup title'"
              :validationName="$v.popup.popup_title"
            />
          </b-form-group>

          <b-form-group
            label="Popup description *"
            class="mb-4"
          >
            <b-form-textarea
              v-model.trim="popup.popup_description"
              placeholder="Enter a compelling description of the giveaway"
              rows="3"
              :class="{ 'is-invalid': submitted && $v.popup.popup_description.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Popup description'"
              :validationName="$v.popup.popup_description"
            />
          </b-form-group>

          <div class="mb-4">
              <div class="d-flex align-items-center justify-content-between">
              <label style="font-weight:400;">Opt-in text *</label>
              <button @click="toggleOptInFields" type="button" class="btn btn-outline-secondary mb-3">Add Additional</button>
            </div>
         <b-form-group
          >
            <b-form-input
              v-model.trim="popup.opt_in_text"
              placeholder="e.g., I agree to participate and accept the terms and conditions"
              :class="{ 'is-invalid': submitted && $v.popup.opt_in_text.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Opt-in text'"
              :validationName="$v.popup.opt_in_text"
            />
          </b-form-group>
          <div v-for="(optInFiled, index) in additionalOptIns" :key="index"
             class="mb-3 mt-3 border rounded-3">
                <div class="d-flex align-items-start gap-2">
                  <b-form-input
                      v-model.trim="additionalOptIns[index]"
                      type="text"
                      :id="'optin-' + index"
                      :class="{ 'is-invalid': additionalOptIns[index].trim() === '' }"
                  >
                  </b-form-input>
                  <b-button
                      variant="outline-danger"
                      class="ms-2"
                      @click.prevent="removeOptIn(index)"
                      title="Remove this answer">
                    <i class="uil uil-trash-alt"></i>
                  </b-button>
                </div>
              </div>
           <span v-if="emptyOptInField" class="text-danger font-size-12 ms-1">Opt In Text can't be empty</span>
          </div>

       

          <b-form-group
            label="Terms & Conditions URL *"
            class="mb-4"
          >
            <b-form-input
              v-model.trim="popup.terms_url"
              placeholder="https://example.com/terms"
              :class="{ 'is-invalid': submitted && $v.popup.terms_url.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Terms & Conditions URL'"
              :validationName="$v.popup.terms_url"
            />
          </b-form-group>

          <div class="mb-4">
            <label class="form-label d-block">Popup image *</label>
            <p class="text-muted mb-3">Upload a banner image for the giveaway (recommended: 955x425 px)</p>

            <div
              v-if="existingImageUrl && !popup.image_file"
              class="current-image-preview mb-3"
            >
              <img :src="existingImageUrl" alt="Current giveaway" />
              <small class="text-muted d-block mt-2">
                Current image will remain unless you upload a new one.
              </small>
            </div>

            <div
              :class="[
                'giveaway-upload',
                submitted && $v.popup.image_file.$error ? 'is-invalid' : '',
                acceptedFileTypeError ? 'has-error' : ''
              ]"
            >
              <vue-dropzone
               id="giweaway-popup"
                ref="giveawayDropzone"
                :options="dropzoneOptions"
                :use-custom-slot="true"
                @vdropzone-files-added="selectFile"
                no-progress-bar
              >
                <div class="giveaway-upload__placeholder">
                  <i class="uil uil-import"></i>
                  <span>Drag and drop an image, or click to browse</span>
                  <small>PNG, JPG up to 1MB</small>
                </div>
              </vue-dropzone>
            </div>
            <div class="d-flex align-items-center mt-3 gap-3" v-if="popup.image_file">
              <span class="text-muted small">{{ popup.image_file.name }}</span>
              <b-button size="sm" variant="outline-danger" @click="removeImage">Remove</b-button>
            </div>
            <validationMessages
              v-if="submitted"
              :fieldName="'Popup image'"
              :validationName="$v.popup.image_file"
            />
            <p v-if="acceptedFileTypeError" class="text-danger mt-2">{{ acceptedFileTypeErrorMessage }}</p>
          </div>
        </section>

        <section class="giveaway-card">
          <header class="giveaway-card__header">
            <h3>Success page content</h3>
            <p>Configure what users see after joining the giveaway</p>
          </header>

          <b-form-group
            label="Success page popup title *"
            class="mb-4"
          >
            <b-form-input
              v-model.trim="popup.success_title"
              placeholder="e.g., You're In!"
              :class="{ 'is-invalid': submitted && $v.popup.success_title.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Success page popup title'"
              :validationName="$v.popup.success_title"
            />
          </b-form-group>

          <b-form-group
            label="Success page popup description *"
            class="mb-4"
          >
            <b-form-textarea
              v-model.trim="popup.success_description"
              placeholder="e.g., Thank you for participating! We'll announce the winner soon."
              rows="3"
              :class="{ 'is-invalid': submitted && $v.popup.success_description.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Success page popup description'"
              :validationName="$v.popup.success_description"
            />
          </b-form-group>

          <b-form-group
            label="Button CTA text *"
            class="mb-4"
          >
            <b-form-input
              v-model.trim="popup.button_cta_text"
              placeholder="e.g., Join Giveaway, Enter Now"
              :class="{ 'is-invalid': submitted && $v.popup.button_cta_text.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Button CTA text'"
              :validationName="$v.popup.button_cta_text"
            />
          </b-form-group>

          <b-form-group
            label="Button landing page URL"
            class="mb-1"
          >
            <b-form-input
              v-model.trim="popup.button_cta_url"
              placeholder="https://example.com/landing-page"
            />
          </b-form-group>
          <small class="text-muted">If you leave the URL blank, the button will not appear</small>
        </section>

        <input type="hidden" name="csrf_token" v-model="csrf_token">

        <footer class="giveaway-modal__footer">
          <b-button variant="outline-secondary" @click="closeModal">Cancel</b-button>
          <b-button variant="dark" type="submit" :disabled="tryingToSubmit">
            <b-spinner v-if="tryingToSubmit" small class="me-2" />
            Update Popup
          </b-button>
        </footer>
      </b-form>
    </div>
  </b-modal>
</template>

<style scoped>
.giveaway-modal {
  padding: 32px;
  background: #f7f8fb;
}

.giveaway-modal__hero {
  margin-bottom: 24px;
}

.giveaway-modal__hero h2 {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 8px;
  color: #151a2d;
}

.giveaway-modal__hero p {
  margin: 0;
  color: #5f6b7d;
  font-size: 16px;
}

.giveaway-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 24px;
  box-shadow: 0 12px 32px rgb(15 23 42 / 6%);
}

.giveaway-card__header h3 {
  margin-bottom: 4px;
  font-size: 20px;
  font-weight: 600;
  color: #151a2d;
}

.giveaway-card__header p {
  margin-bottom: 24px;
  color: #5f6b7d;
}

.giveaway-datetime {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.giveaway-datetime__label {
  font-weight: 600;
  color: #151a2d;
}

.giveaway-datetime__inputs {
  display: flex;
  gap: 12px;
  align-items: center;
}

.giveaway-input-icon {
  position: relative;
  flex: 1;
}

.giveaway-input-icon__icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #5f6b7d;
  font-size: 18px;
  cursor: pointer;
  pointer-events: auto;
}

.giveaway-input-icon .form-control {
  width: 100%;
}

.giveaway-datetime__inputs .form-control {
  padding: 12px 16px;
  border-radius: 12px;
  background: #f1f3f7;
  border: 1px solid transparent;
}

.giveaway-datetime__inputs .form-control:focus {
  border-color: #6366f1;
  background: #ffffff;
  box-shadow: none;
}

.giveaway-upload {
  border: 2px dashed #d3d8e6;
  border-radius: 16px;
  background: #f7f8fb;
  padding: 32px;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.giveaway-upload.is-invalid {
  border-color: #f97373;
}

.giveaway-upload.has-error {
  border-color: #f97373;
  background: #fff5f5;
}

.giveaway-upload__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #5f6b7d;
  font-size: 14px;
}

.giveaway-upload__placeholder i {
  font-size: 32px;
  color: #151a2d;
}

.giveaway-upload__placeholder small {
  color: #a0aec0;
}

.current-image-preview {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  background: #ffffff;
  text-align: center;
}

.current-image-preview img {
  max-width: 100%;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.giveaway-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
}

@media (max-width: 767.98px) {
  .giveaway-modal {
    padding: 20px;
  }

  .giveaway-card {
    padding: 20px;
  }

  .giveaway-datetime__inputs {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>

